/**
 * 쪽 넘김(이전/다음 + 현재 쪽·전체 건수) — 관리 목록 공용(2026-09-15).
 * 한 쪽에 다 들어가면 버튼 대신 건수만 보여 준다(누를 것이 없는 버튼은 소음이다).
 */
export function Pager({
  total,
  limit,
  offset,
  onChange,
  disabled,
}: {
  total: number;
  limit: number;
  offset: number;
  onChange: (offset: number) => void;
  disabled?: boolean;
}) {
  if (total === 0 || limit <= 0) {
    return null;
  }
  if (total <= limit) {
    return <div className="hint pager">총 {total}건</div>;
  }
  const page = Math.floor(offset / limit) + 1;
  const pages = Math.ceil(total / limit);
  return (
    <div className="row pager">
      <button className="ghost" disabled={disabled || offset === 0} onClick={() => onChange(Math.max(0, offset - limit))}>
        이전
      </button>
      <span className="hint">
        {page} / {pages}쪽 · 총 {total}건
      </span>
      <button className="ghost" disabled={disabled || offset + limit >= total} onClick={() => onChange(offset + limit)}>
        다음
      </button>
    </div>
  );
}
